module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x10@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x10@2x.png
// module id = 80
// module chunks = 3